<template>
	<div class="goods-info-body">
		<div class="basic-info-container">
			<div class="fx-title">
				<p>基础信息</p>
			</div>
			<div class="basic-info">
				<div>商品名称： {{goodsName}}</div>
				<div>所属品类： {{bigCatogery}} <i class="el-icon-arrow-right"/> {{smallCatogery}}</div>
				<div>商品介绍： <span>{{goodsExplain}}</span></div>
			</div>
			<div class="verify-status">
				<i
					v-show="auditShopCount !== 0"
					class="status-icon"
					:class="statusIcon"
				/>
			</div>
		</div>
		<div class="basic-img-container">
			<!-- <div class="img-box">
				<div class="fx-title">
					<p>商品展示图</p>
				</div>
				<img :src="item.imgurl" alt="" v-for="(item) in showImg" :key="item.id">
			</div> -->
			<div class="img-box">
				<div class="fx-title">
					<p>商品详情图</p>
				</div>
				<w-image :src="item.imgurl" alt="" v-for="(item) in detailImg" :key="item.id"></w-image>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'goodsInfo',
	props: {
		goodsId: {
			type: String
		}
	},
	data () {
		return {
			goodsName: '',
			bigCatogery: '',
			smallCatogery: '',
			goodsExplain: '',
			auditShopCount: '',
			statusIcon: '',
			showImg: [
				{ id: '', imgname: '', imgurl: '', imgtype: 0 }
			],
			detailImg: [
				{ id: '', imgname: '', imgurl: '', imgtype: 1 }
			]
		}
	},
	created () {
		this.getGoodsInfo()
		this.getImgInfo()
	},
	methods: {
		getGoodsInfo () {
			let params = {
				id: this.goodsId,
				bcId: '0',
				hiddenFlag: +sessionStorage.getItem('goodHiddenFlag'),
				scId: '0',
				goodsName: '',
				saleState: 2,
				auditState: 4,
				page: 1,
				size: 20,
				order: 1,
				orderKey: '',
				unitFlag: -1,
				sourceflag: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data.recordList[0]
					this.goodsName = data.goodsName
					this.auditShopCount = data.auditShopCount
					this.goodsExplain = data.goodsExplain
					this.bigCatogery = data.bcName
					this.smallCatogery = data.scName
					switch (data.auditState) {
					case '待提交':
						this.statusIcon = 'submit'
						break
					case '待审核':
						this.statusIcon = 'pending'
						break
					case '通过':
						this.statusIcon = 'pass'
						break
					case '驳回':
						this.statusIcon = 'reject'
						break
					}
				}
			})
		},
		getImgInfo () {
			let params = {
				id: this.goodsId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsImgInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.showImg = []
					this.detailImg = []
					res.data.forEach(dataItem => {
						if (dataItem.imgtype === 0) {
							this.showImg.push(dataItem)
						} else {
							this.detailImg.push(dataItem)
						}
					})
				}
			})
		},
		getInfo () {
			let params = {
				goodsId: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productBaseInfo/get`,
				data: params
			}).then(res => {
				if (res.result) {
					this.goodsName = res.data.productname
					this.bigCatogery = res.data.bigcategoryname
					this.smallCatogery = res.data.smallcategoryname
					this.introduction = res.data.goodsexplain
					this.showImg = res.data.showImgs
					this.detailImg = res.data.detailImgs
				} else {
					this.message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.goods-info-body {
	display flex
	flex: 1
	flex-direction column
	text-align left
	.fx-title {
		margin 10px 0
		font-weight 700
	}
	.basic-info-container {
		position relative
		.basic-info {
			padding-left: 12px
			div {
				margin 10px 0
				span {
					display inline-block
					width: 400px
					height: 100px
					vertical-align top
					overflow-y auto
				}
			}
		}
		.verify-status {
			position absolute
			top: 50px
			left 550px
			width: 200px
			height 100px
			.status-icon {
				display inline-block
				width: 108px
				height: 56px
			}
			.pass {
				background-image: url('~images/icon/pass.png')
			}
			.pending {
				background-image: url('~images/icon/pending.png')
			}
			.reject {
				background-image: url('~images/icon/reject.png')
			}
			.submit {
				background-image: url('~images/icon/submit.png')
			}
		}
	}
	.basic-img-container {
		display flex
		flex: 1
		.img-box {
			flex: 1
			img {
				float left
				width: 130px
				height: 130px
				margin 0 0 10px 10px
				border-radius 6px
			}
		}
	}
}
</style>
